export const DEFAULT_IMG_TAG_FALLBACK_CONFIG = {
  size: 'md',
  format: 'png',
  resolution: '1x'
};

export default {
  DEFAULT_IMG_TAG_FALLBACK_CONFIG
};
